import React from 'react'
import PropTypes from 'prop-types'
import Divider from '@mui/material/Divider'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import Tabs from '~/components/Tabs'
import { LISTING_DETAIL_PATH } from '~/constants/routes'
import { LISTING_TABS } from '~/constants/tabs'

const TABS = [
  { value: LISTING_TABS.VARIANT, label: 'variant' },
  { value: LISTING_TABS.PRODUCT, label: 'Product' }
]

function ListingDetailTabs ({ value }) {
  const navigate = useNavigate()
  const { guid } = useParams()
  const onChange = (event, tab) => {
    const redirect = generatePath(LISTING_DETAIL_PATH, { guid, tab })
    navigate(redirect)
  }

  return (
    <>
      <Tabs
        tabs={TABS}
        value={value}
        onChange={onChange}
      />
      <Divider />
    </>
  )
}

ListingDetailTabs.propTypes = {
  value: PropTypes.string.isRequired,
}

export default ListingDetailTabs
